export const environment = {
  production: false,
  // endpoint: 'https://pomac.info/api/backend/public/api',
  endpoint: 'https://backend-beta-dev.pomac.info/public/api',
  currency: 'SAR',
  // baseUrl: 'https://pomac.info/api/backend/public',
  baseUrl: 'https://backend-beta-dev.pomac.info/public',
  // website: 'https://pomac.info',
  website: 'https://beta.pomac.info',
  currentUserKey: 'pomacCurrentUser', // user key in local storage
};
